import { JwtHelperService } from '@auth0/angular-jwt';
import { ErrorHandlerService } from '.';
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
    }
    AuthenticationService.prototype.isAuthenticated = function () {
        var helper = new JwtHelperService();
        var token = localStorage.getItem('authorization');
        var errorHandlerService = new ErrorHandlerService();
        if (token) {
            if (token != null && token.length > 0) {
                return true;
            }
            else {
                return false;
            }
            //errorHandlerService.throwError("error");
        }
        else {
            return false;
            //errorHandlerService.throwError("error");
        }
    };
    return AuthenticationService;
}());
export { AuthenticationService };
//# sourceMappingURL=authentication.service.js.map